<template>
  <div>
  <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKey" :canSave="false"
    onlyDialogHeaderName="Creating a Special Assessment Record"
    @crudDialogClose="crudDialogClose" dialogDynamicWidth="650">
    <template v-slot:[`editedItem`]="{}">
      <v-row>
        <v-col cols="2" class="ma-0 pb-0 pt-0">
          <v-text-field class="input-text-size pa-0 mt-3" label="Tax Year"
          v-model="editedItem.taxYear" readonly tabindex="-1" v-if="!isItAllowEditsForSA" />
          <CommonDropDowns class="mt-n1 mr-1" :isItTaxYearWithNewYear="isItAllowEditsForSA"
          @change="(val, whichField) => { dataFromCommonDropDowns(val, whichField);
          handleCalculatedTax() }" :taxYearValue="editedItem.taxYear" />
        </v-col>
        <v-col cols="2" class="ma-0 pb-0 pt-0">
          <v-text-field class="input-text-size pa-0 mt-3"
           @click="onTaxIdClick()" label="Tax ID"
            @blur="checkTaxIdIsFree()" @change="checkTaxIdIsFree()"
            :error-messages="taxIdInUseMsg"
            v-model.number="editedItem.taxId" :rules="isTaxSaExits"
            autocomplete="off" />
        </v-col>
        <v-col cols="2" class="ma-0 pb-0 pt-0">
          <v-text-field class="input-text-size pa-0 mt-3"
           label="Base ID" v-model.number="editedItem.baseId" />
        </v-col>
        <v-col cols="4" class="ma-0 pb-0 pt-0">
          <v-text-field class="input-text-size pa-0 mt-3" label="Parcel ID"
            v-model="editedItem.propertyOrParcelId"
            @blur="formatToPidWithDashes('propertyOrParcelId')"
            @focus="formatToPidWith('propertyOrParcelId'), $event.target.select()"
            v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="2" class="ma-0 pb-0 pt-0">
          <v-text-field class="input-text-size pa-0 mt-3" label="Owner Number"
          v-model="editedItem.ownerId" v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="4" class="ma-0 pb-0 pt-0">
         <CommonDropDowns class="mt-n4" :isItTaxType=true
          @change="dataFromCommonDropDowns"
          :taxTypeValue="editedItem.taxType" :taxTypeRequired="true" />
        </v-col>
        <v-col cols="4" class="ma-0 pb-0 pt-0">
          <CommonDropDowns class="mt-n4" :isItTaxDistrict=true
            @change="(val, whichField) => { dataFromCommonDropDowns(val, whichField);
               handleCalculatedTax() }"
            :taxDistrictValue="editedItem.schoolDistrict" :isItTaxDistrictRequired="true"
            taxDistrictFilterFieldsName="isSpecialAssessment" />
        </v-col>
        <v-col cols="4" class="ma-0 pb-0 pt-0">
          <v-text-field class="input-text-size pa-0 mt-n1"
          label="Tax/ Assessment Amount" v-model="editedItem.totalTax"
          :value="taxAmtFormatted.totalTax" :rules="rules"
          @blur="roundAmount('totalTax'), handleCalculatedTax()"
          @focus="amountToNum('totalTax'), $event.target.select()" />
        </v-col>
        <v-col cols="4" class="ma-0 pb-0 pt-0" />
        <v-col cols="8" class="d-flex justify-space-between ma-0 pb-0 pt-0">
          <label class="input-text-size red--text">Total Levies: </label>
          <label class="input-text-size">{{ totalLevies || 0 }}</label>
          <label class="input-text-size red--text">Calculated Tax Amount:</label>
          <label class="input-text-size">{{ calculatedTaxAmount || 0}}</label>
        </v-col>
        <v-col cols="8">
        <v-row>
        <v-col cols="12" class="ma-0 pb-0 pt-0">
          <v-textarea class="input-text-size pa-0 mt-2 dec-line-height mb-n9"
            outlined rows="5" label="Legal" v-model="editedItem.legalDesc"
            v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="ma-0 pb-0 pt-0">
          <CommonDropDowns class="mt-2" :isItTaxAdjTypes=true
          @change="dataFromCommonDropDowns"
          :taxAdjTypesValue="editedItem.adjTypes" :taxAdjTypesRequired="true" />
          <ClarionDateControl class="input-text-size pa-0 mt-n4 mb-1"
          label="Cert Date" :isToggle="false"
          :isRequired="true" v-model="editedItem.certDateValue" />
          <v-row>
            <v-col cols="6" class="ma-0">
              <v-text-field class="input-text-size pa-0 mt-n1" label="Cert Number"
                v-model="editedItem.certificateNumber" />
            </v-col>
            <v-col cols="6" class="ma-0">
              <v-text-field class="input-text-size pa-0 mt-n1" label="Invoice Number"
                v-model="editedItem.invoiceNumber" />
            </v-col>
          </v-row>
          <ClarionDateControl class="input-text-size mt-n6"
           :isToggle="false" v-model="editedItem.penaltyStartDate"
           label="Penalty Start Date" :rules="rules"
           @blurred="penaltyStartDateOnBlurred" />
        </v-col>
        <v-col cols="6" class="ma-0 pb-0 pt-0">
          <CommonDropDowns class="mt-15" :isItTaxFee=true @change="dataFromCommonDropDowns"
           :taxFeeNumValue="editedItem.feeNumber" :taxFeeRequired="getIsDisabledForFeeNumber()" />
          <v-text-field class="input-text-size pa-0"
           @change="getIsDisabledForFeeNumber()" label="Fee Amount"
            v-model="editedItem.feeAmount" :rules="rulesFeeAmt" @blur="roundAmount('feeAmount')"
            @focus="amountToNum('feeAmount'), $event.target.select()" />
          <CommonDropDowns class="pa-0 mt-n5" :isItstaCode=true @change="dataFromCommonDropDowns"
          :staCodeValue="editedItem.staCode" />
        </v-col>
      </v-row>
      </v-col>
      <v-col cols="4">
        <v-text-field class="input-text-size pa-0" label="Land"
          v-model.number="editedItem.land" @blur="handleCalculatedTax()" />
        <v-text-field class="input-text-size pa-0 mt-n1" label="Improvements"
          v-model.number="editedItem.improvements" @blur="handleCalculatedTax()" />
        <v-text-field class="input-text-size pa-0 mt-n1" label="Mobile Home"
          v-model.number="editedItem.mobileHome" @blur="handleCalculatedTax()" />
        <v-text-field class="input-text-size pa-0 mt-n1" label="Penalty"
          v-model.number="editedItem.assessorPenalty" @blur="handleCalculatedTax()" />
        <v-text-field class="input-text-size pa-0" label="Exemptions"
          v-model.number="editedItem.exemptions" @blur="handleCalculatedTax()" />
        <v-text-field class="input-text-size pa-0 mt-n1" label="Net Assessed"
          :value="netAssesedValue" readonly tabindex="-1" />
      </v-col>
      </v-row>
    </template>
    <template v-slot:[`additionalActionsAfterSave`]="{}">
      <v-btn class="input-text-size ml-6" text color="blue darken-1"
      @click="upsertRecordsFromCrud()"
      :disabled="disableSaveBtn || !!taxIdInUseMsg">Save</v-btn>
    </template>
  </CRUDDialog>
  <CommonPopUp v-model="errorPopUpFlagValue"
     :enableFlashTypeMsg="false" :custumWidth="300">
     <template v-slot:customsLabelOrInfo>
      <p>Levy Records not Found</p>
      <p class="input-text-size">There are no levy records for tax year
{{ editedItem.taxYear }} and tax district {{ editedItem.schoolDistrict }}. Please
go copy levies to the new tax year and then attempt to create this SA record again.</p>
    </template>
    <template v-slot:[`customsButtonsForPopUp`]="{}">
      <v-btn class="input-text-size" text color="blue darken-1"
        @click="errorPopUpFlagValue = false">OK</v-btn>
    </template>
  </CommonPopUp>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { amountFormat, amountToNumber, pIdFormat } from '../../../../util/shared/vue-global';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import PenaltyStartDateSnap from '../../common-utils/PenaltyStartDateSnap.mixin.vue';
import '../../../../assets/style.css';

export default {
  mixins: [GlobalToCaps, PenaltyStartDateSnap],
  data() {
    return {
      taxAmtFormatted: {
        totalTax: null,
        land: null,
        improvements: null,
        mobileHome: null,
        assessorPenalty: null,
        exemptions: null,
      },
      totalLevies: 0,
      grossAssessed: 0,
      netAssessed: 0,
      calculatedTaxAmount: 0,
      errorPopUpFlagValue: false,
      leviesMissing: false,
      taxIdInUseMsg: '',
    };
  },
  mounted() {
    this.roundAmount('totalTax');
    this.roundAmount('feeAmount');
  },
  components: {
    CommonDropDowns,
    ClarionDateControl,
    CRUDDialog,
    CommonPopUp,
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isItAllowEditsForSA() {
      return (this.taxSettingItem && this.taxSettingItem.allowEditsForSA) || false;
    },
    rules() {
      return [
        (v) => {
          if (Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    rulesFeeAmt() {
      return [
        (v) => {
          if (Number(this.editedItem.feeNumber)) return !!v || 'Required.';
          return true;
        },
      ];
    },
    isTaxSaExits() {
      return [
        (v) => !!v || 'Required.',
        () => {
          if (!this.taxSettingItem.specialAssesment) {
            return 'Required Omitted Properties from Tax-setting';
          }
          return true;
        },
      ];
    },
    netAssesedValue() {
      return amountToNumber(this.editedItem.land) + amountToNumber(this.editedItem.improvements)
      + amountToNumber(this.editedItem.mobileHome) + amountToNumber(this.editedItem.assessorPenalty)
      - amountToNumber(this.editedItem.exemptions);
    },
  },
  watch: {
    // The id changing - typed, or replaced by the 1.2s auto-fill poll - makes any
    // standing "already exists" message about the old id, so drop it. The blur/change
    // handler and the save-time check put it back if the new id is taken too.
    'editedItem.taxId': function onTaxIdChanged() {
      this.taxIdInUseMsg = '';
    },
    // Tax Year is a dropdown here when allowEditsForSA is on, and it never blurs the
    // Tax ID field, so re-ask on its own - the same id in another year is a different
    // account and may well be taken.
    'editedItem.taxYear': function onTaxYearChanged() {
      this.taxIdInUseMsg = '';
      this.checkTaxIdIsFree();
    },
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'createSA',
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', [
      'setItem',
      'setIsVisible',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setIsTaxIdClicked',
    ]),
    ...mapActions('tax/taxInquires', [
      'calculateTaxes',
      'checkTaxIdExists',
    ]),
    dataFromCommonDropDowns(val, whichField) {
      if (whichField === 'taxDistrict') this.editedItem.schoolDistrict = val;
      this.editedItem[whichField] = val;
    },
    roundAmount(val) {
      const formatedAmt = amountFormat(amountToNumber(this.editedItem[val]));
      this.editedItem[val] = formatedAmt;
      this.taxAmtFormatted[val] = formatedAmt;
    },
    amountToNum(val) {
      const formatedAmt = amountToNumber(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.taxAmtFormatted[val] = formatedAmt;
    },
    // Nothing stops a county typing a Tax ID that is already on a record for the year,
    // and the pre-filled id is only the highest one seen when the poll last ran, so two
    // workstations can be holding it at the same time. Ask the server.
    async checkTaxIdIsFree() {
      const taxYear = Number(this.editedItem.taxYear);
      const taxId = Number(this.editedItem.taxId);
      if (!taxYear || !taxId) {
        this.taxIdInUseMsg = '';
        return true;
      }
      const res = await this.checkTaxIdExists({ taxYear, taxId });
      // The auto-fill poll may have moved the id while the query was in flight; a
      // verdict about the id we asked about would be wrong against the one on screen.
      if (Number(this.editedItem.taxId) !== taxId
        || Number(this.editedItem.taxYear) !== taxYear) return true;
      // res is null when the check itself failed - don't block the save on that, the
      // upsert resolver refuses duplicates too.
      this.taxIdInUseMsg = res && res.exists ? `Tax ID ${taxId} already exists for ${taxYear}` : '';
      return !this.taxIdInUseMsg;
    },
    async upsertRecordsFromCrud() {
      const validate = this.$refs.crudDialog.validateForm();
      if (!validate) return;
      // Re-run the levy lookup on the way out: the tax year/district or amounts may
      // have changed since the last @change/@blur without us re-checking, and the
      // popup itself should only ever appear from this Save-time check.
      await this.handleCalculatedTax();
      if (this.leviesMissing) {
        this.errorPopUpFlagValue = true;
        return;
      }
      // Re-check on the way out: the id can be claimed by another workstation between
      // the blur check and this click, and an auto-filled id was never blurred at all.
      const taxIdIsFree = await this.checkTaxIdIsFree();
      if (!taxIdIsFree) return;
      const val = this.editedItem;
      this.$emit('upsertCallBack', val);
    },
    getIsDisabledForFeeNumber() {
      if (Number(this.editedItem.feeAmount)) return true;
      return false;
    },
    onTaxIdClick() {
      this.setIsTaxIdClicked(true);
    },
    crudDialogClose() {
      this.setIsVisible(['createOmit', false]); // to close omit dialog
    },
    formatToPidWithDashes(val) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const formattedPid = pIdFormat(this.editedItem[val], formatPidPositions);
      this.editedItem[val] = formattedPid;
    },
    formatToPidWith(val) {
      const formatedPid = (this.editedItem[val] || '').replace(/-/g, '');
      this.editedItem[val] = formatedPid;
    },
    async handleCalculatedTax() {
      const selectedItem = this.editedItem;
      const criteria = {
        land: amountToNumber(selectedItem.land),
        improvements: amountToNumber(selectedItem.improvements),
        mobileHome: amountToNumber(selectedItem.mobileHome),
        exemptions: amountToNumber(selectedItem.exemptions),
        totalTax: amountToNumber(selectedItem.totalTax),
        schoolDistrict: selectedItem.schoolDistrict || selectedItem.taxDistrict || '',
        taxYear: selectedItem.taxYear,
        penalty: amountToNumber(selectedItem.assessorPenalty),
      };
      const response = await this.calculateTaxes({ criteria });
      // Remember whether levy records are missing; the popup itself only fires on Save
      // (see upsertRecordsFromCrud), not from this live @change/@blur lookup.
      this.leviesMissing = response.statusCode === 201;
      this.totalLevies = amountFormat(response.totalLevies);
      this.grossAssessed = amountFormat(response.grossAssessed);
      this.netAssessed = amountFormat(response.netAssessed);
      this.calculatedTaxAmount = amountFormat(response.calculatedTax);
      return response;
    },
  },
};
</script>
